export default "__VITE_ASSET__DrskZMu4__"